export default class UnexpectedSalonTypeError extends Error {
    constructor(type: string) {
        super(`Unexpected salon type: ${type}`);
        this.name = "UnexpectedSalonTypeError";
    }
}